const LICENSE_TUPLE_QUANTITY_UNLIMITED = 'UNLIMITED';

export {LICENSE_TUPLE_QUANTITY_UNLIMITED};
